module.exports = __webpack_public_path__ + "static/media/18.49b48c6d.jpg";